import React, { useEffect, useState } from 'react';
import { getLabBurnInDegradation } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function BurnInDegradationPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [data, setData] = useState({ rows: [], sources: [] });

  useEffect(() => {
    getLabBurnInDegradation(sharedQuery).then(setData);
  }, [sharedQuery]);

  return (
    <div className="lab-page">
      <LabCard title="Degrado burn-in" description="Confronta la fase iniziale e finale del burn-in per capire se alcuni step stanno peggiorando nel tempo.">
        <LabTable
          rows={data.rows}
          emptyTitle="Nessuna misura burn-in trovata."
          emptyDescription="Importa prima i file burn-in, poi Smarti Lab potrà confrontare fase iniziale e finale."
          columns={[
            { key: 'stepName', label: 'Step' },
            { key: 'units', label: 'Unità' },
            { key: 'failRate', label: 'Fail rate %' },
            { key: 'driftDelta', label: 'Delta deriva' },
            { key: 'driftDirection', label: 'Direzione' },
            { key: 'topSourceLabels', label: 'Source label principali', render: (value) => (value || []).join(', ') || '—' },
            { key: 'riskLabel', label: 'Rischio', render: (value) => <LabRiskBadge label={value} /> },
          ]}
        />
      </LabCard>
      <LabCard title="Insight per sorgente" description="Mostra quali source label concentrano più fail burn-in e meritano un controllo mirato.">
        <LabTable rows={data.sources} columns={[
          { key: 'sourceLabel', label: 'Source label' },
          { key: 'totalRows', label: 'Righe' },
          { key: 'failCount', label: 'Conteggio fail' },
          { key: 'firstFailureAt', label: 'Primo fail' },
          { key: 'failingSteps', label: 'Step in fail', render: (value) => (value || []).join(', ') || '—' },
        ]} />
      </LabCard>
    </div>
  );
}
